export default __webpack_public_path__ + "static/media/cx_cover_jcs3.b111d035.jpg";